// extracted by mini-css-extract-plugin
module.exports = {"component":"Breadcrumbs_component__57qhD","component__item":"Breadcrumbs_component__item__eZhD_","component__divider":"Breadcrumbs_component__divider__GnoRo"};